import React from 'react';
import googlePlayImg from '../../assets/images/google-play.png';
import appStoreImg from '../../assets/images/app-store.png';
import './AppDownloadSection.css';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.digirasa.client';
const APP_STORE_URL = 'https://apps.apple.com/in/app/digirasa/id6736368836';
const PLAY_STORE_QR_URL = `https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=${encodeURIComponent(PLAY_STORE_URL)}`;
const APP_STORE_QR_URL = `https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=${encodeURIComponent(APP_STORE_URL)}`;

const AppDownloadSection = () => (
  <section className="app-dl">
    <div className="container">
      <div className="app-dl__content">
        <span className="section-tag">For more offers &amp; Discounts</span>
        <h2 className="section-title">
          Download Our APP
          <br />
          Order Online
        </h2>
        <p>
          We are a trusted nutritious food brand with 2+ years of experience, delivering
          high-quality traditional foods with a focus on health and authenticity.
        </p>
        <div className="app-dl__actions">
          <div className="app-dl__badges">
            <a
              href="https://play.google.com/store/apps/details?id=com.digirasa.client"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={googlePlayImg} alt="Get it on Google Play" />
            </a>
            <a
              href="https://apps.apple.com/in/app/digirasa/id6736368836"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={appStoreImg} alt="Download on App Store" />
            </a>
          </div>
          <div className="app-dl__qr-list">
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="app-dl__qr"
              aria-label="Scan QR code for Google Play"
            >
              <img src={PLAY_STORE_QR_URL} alt="Digirasa Google Play QR code" />
              <span>Scan for Google Play</span>
            </a>
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="app-dl__qr"
              aria-label="Scan QR code for App Store"
            >
              <img src={APP_STORE_QR_URL} alt="Digirasa App Store QR code" />
              <span>Scan for App Store</span>
            </a>
          </div>
        </div>
        <p className="app-dl__note">* Free delivery within 2kms radius from the kitchen</p>
      </div>
    </div>
  </section>
);

export default AppDownloadSection;
